<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="收银台"></el-page-header>
      <div class="row-container center-align" style="height: 140px;">
        <div class="colomn-container center" style="height: 100%;width: 80%;">
          <span style="font-size: 22px; color: #333333;">{{orderAviliable?'订单提交成功，请尽快付款！':'订单已超时，请重新下单'}}订单号：{{orderInfo.checkOrderId}}</span>
          <span style="font-size: 18px; color: #666666;margin-top: 8px;" v-if="orderAviliable">{{'请您在 '+countDownHour+'时'+countDownMinute+'分'+countDownSecond+'秒内完成支付，否则订单会被自动取消'}}</span>
        </div>
        <span style="font-size: 18px; color: #333333;width: 20%;text-align: right;" v-if="orderAviliable">应付金额&nbsp;&nbsp;<b style="color: #dd3131; font-size: 36px;">{{orderInfo.amount}}</b>&nbsp;&nbsp;元</span>
      </div>
      <div class="pay-container">
        <AreaHeader style="margin-top: 0px;" title="支付方式"></AreaHeader>
        <el-radio-group v-model="currentChannel" size="medium" style="width: 100%;display: flex;flex-direction: column;margin-top: 20px;align-items: center;justify-content: center;">
          <el-radio class="radio" v-for="channel in channels" :key="channel.channelId" :label="channel.channelId" border>
            <img class="pay-icon" :src="channel.channelId == 'fast_pay'?'../../../static/image/ic_bank.png':'../../../static/image/ic_zfb.png'" />
            {{channel.channelName}}
            <b style="color: #666666;" v-if="channel.channelId == 'fast_pay'&&bankNoText.length>0">{{bankNoText}}</b>
          </el-radio>
          <el-button type="primary" class="btn-fast-pay" plain @click="toAddBank" :icon="hasBankCard?'el-icon-edit':'el-icon-plus'">{{hasBankCard?'  换卡支付':'  去绑定银行卡支付'}}</el-button>
        </el-radio-group>
        <el-button class="btn-pay" type="danger" @click="pay">立即支付</el-button>
      </div>
      <el-dialog title="绑定银行卡" :visible.sync="bankDialogVisible" center destroy-on-close width="860px" :close-on-press-escape="false">
        <el-form label-width="140px" label-position="right" class="dialog" :model="bindBankInfo">
          <div style="width: 100%;margin-bottom: 30px;font-size: 18px;color: #666;text-align: left;padding-left: 20px;">
            <p>温馨提示：</p>
            <p>1、请绑定工商银行、农业银行、中国银行、建设银行、交通银行的储蓄卡。</p>
            <p>2、不支持绑定信用卡。</p>
          </div>
          <el-form-item class="form-item" label="*银行卡号：">
              <el-input v-model="bindBankInfo.cardId" type="number" autocomplete="off" placeholder="请输入银行卡号"></el-input>
          </el-form-item>
          <el-form-item label="*姓名：" class="form-item">
              <el-input v-model="bindBankInfo.userName" type="text" autocomplete="off" placeholder="请输入银行卡用户姓名"></el-input>
          </el-form-item>
          <el-form-item label="*身份证号码：" class="form-item">
              <el-input v-model="bindBankInfo.idNo" type="text" autocomplete="off" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="*银行手机号：" class="form-item">
              <el-input v-model="bindBankInfo.telNo" type="text" autocomplete="off" placeholder="请输入银行卡绑定手机号码"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="bankDialogVisible = false" style="margin-right: 30px;">取消</el-button>
          <el-button type="primary" @click="bindBank" style="margin-left: 30px;">绑定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="绑定银行卡验证" :visible.sync="bindCodeDialogVisible" center destroy-on-close width="880px" :close-on-press-escape="false">
        <div class="dialog">
          <img src="../../../static/image/ic_phone.png" style="width: 60px; height: 60px;"/>
          <span style="color: #333333;font-size: 22px;margin-top: 20px;">使用手机验证码</span>
          <span style="color: #666666;font-size: 18px;margin-top: 10px;">当前手机号{{bindBankInfo.telNo}}</span>
          <div class="row-container" style="margin-top: 30px;align-items: center;justify-content: center;">
            <el-input style="width: 60%;" placeholder="输入验证码" v-model="verify_code" maxlength=6 clearable></el-input>
            <el-button style="width: 40%;margin-left: 20px;" class="btn-verify" size="medium" @click="bindBank" type="primary" :loading="vloading" :disabled="verify_disable">{{btn_verify}}</el-button>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bindConfirm">绑定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="支付验证" :visible.sync="payCodeDialogVisible" center destroy-on-close width="750px" :close-on-press-escape="false" :before-close="beforeClose">
        <div class="dialog">
          <img src="../../../static/image/ic_phone.png" style="width: 60px; height: 60px;"/>
          <span style="color: #333333;font-size: 22px;margin-top: 20px;">使用手机验证码</span>
          <span style="color: #666666;font-size: 18px;margin-top: 10px;">当前手机号{{fastPayInfo.telNo}}</span>
          <div class="row-container" style="margin-top: 30px;align-items: center;justify-content: center;">
            <el-input style="width: 60%;" placeholder="输入验证码" v-model="pay_verify_code" maxlength=6 clearable></el-input>
            <el-button style="width: 40%;margin-left: 20px;" class="btn-verify" size="medium" @click="getPayVerifyCode" type="primary" :loading="pay_vloading" :disabled="pay_verify_disable">{{pay_btn_verify}}</el-button>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="payConfirm">认证支付</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="支付宝支付" :visible.sync="qrcodeVisble" width="400px" :close-on-click-modal='dialogClosable' :close-on-press-escape="false" :before-close="beforeClose">
          <div class="dialog-wrapper">
              <img :src="qrCode" style="width: 200px; height: 200px;"/>
          </div>
      </el-dialog>
      <el-dialog title="支付中..." :visible.sync="fastPayStatusVisble" width="400px" :close-on-click-modal='fastDialogClosable'>
          <div
          class="dialog-wrapper"
          v-loading="loading"
          element-loading-text="正在获取支付结果..."
          element-loading-spinner="el-icon-loading">

          </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import AreaHeader from '@/components/widgets/area-header.vue'
  export default {
    components:{
      AreaHeader,
    },
    data () {
      return {
        orderInfo:{},
        countDownHour:'00',
        countDownMinute:'00',
        countDownSecond:'00',
        currentChannel:"",
        bankDialogVisible:false,
        bindCodeDialogVisible:false,
        btn_verify:'获取验证码',
        verify_disable:false,
        codeDialogType:0,
        verify_second:60,
        verify_status:true,
        verify_code:'',
        vloading:false,
        payCodeDialogVisible:false,
        pay_btn_verify:'获取验证码',
        pay_verify_disable:false,
        pay_verify_second:60,
        pay_verify_status:true,
        pay_verify_code:'',
        pay_vloading:false,
        pay_mInterval:{},
        hasBankCard:false,
        bindBankInfo:{
          cardId:"",
          idNo:"",
          telNo:'',
          userName:'',
          bizType: "SH"
        },
        fastPayInfo:{
          telNo:''
        },
        bankNoText:"",
        toAddBankText:"",
        channels:[],
        zfbInterval:{},
        qrCode:{},
        qrcodeVisble:false,
        outTradeNo:'',
        dialogClosable:false,
        fastDialogClosable:false,
        fastPayStatusVisble:false,
        orderAviliable:true,
        loading:true
      }
    },
    created() {
      this.orderInfo = JSON.parse(sessionStorage.getItem('checkPlaceOrderInfo'))
      this.startCountDown()
      this.getPayChannels()
    },
    methods:{
      goBack(){
          this.$router.go(-1)
      },
      startCountDown(){
        var timeMill = this.orderInfo.payCountdown
        var currentTimeMill = Date.parse(new Date())
        console.log('netMill:'+timeMill)
        console.log('currentMill:'+currentTimeMill)
        if(currentTimeMill > timeMill){
            return
        }
        var totalSecond = (timeMill - currentTimeMill) / 1000;
        console.log('countdown:'+totalSecond)
        var that = this
        this.interval = setInterval(function () {
          // 秒数
          var second = totalSecond;
          // 小时位
          var hr = Math.floor(second / 3600);
          var hrStr = hr.toString();
          if (hrStr.length == 1) hrStr = '0' + hrStr;

          // 分钟位
          var min = Math.floor((second - hr * 3600) / 60);
          var minStr = min.toString();
          if (minStr.length == 1) minStr = '0' + minStr;

          // 秒位
          var sec = Math.floor(second - hr * 3600 - min * 60);
          var secStr = sec.toString();
          if (secStr.length == 1) secStr = '0' + secStr;
          that.countDownHour=hrStr
          that.countDownMinute=minStr
          that.countDownSecond=secStr
          totalSecond--;
          if (totalSecond < 0) {
            clearInterval(that.interval);
            console.log("倒计时结束")
            that.countDownHour='00'
            that.countDownMinute='00'
            that.countDownSecond='00'
            this.orderAviliable = false
          }
        }, 1000);
      },
      getPayChannels(){
          this.wjtHttp.get(this,'/api/adapay/v1/channels/pc',{},true,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.dialogVisible = true
                this.channels = data.data
                var fastPay = this.channels.find(item => item.channelId == "fast_pay")
                if(fastPay != null){
                  this.getFastPayInfo()
                }
            }else{
              this.$message({
                message:(data.msg&&data.msg.length > 0)?data.msg:'获取支付渠道异常',
                type:'error'
              })
            }
          },(err)=>{
              console.log(err)
          })
      },
      qrcodeRefresh(){
          this.payApply('alipay_qr')
      },
      beforeClose(done) {
        this.$confirm('<span style="font-size:18px; color:#DD3131">如关闭，需等待一分钟后再次打开，请确认是否关闭?</span>', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }).then(() => {
                  this.qrcodeVisble = false
                  this.payCodeDialogVisible = false
                }).catch(() => {

                });
      },
      //获取绑定的银行卡信息
      getFastPayInfo(){
        this.wjtHttp.get(this,'/api/adapay/v2/fastpay/card/info/SH',{},true,(res)=>{
            var data = res.data
            if(data.code == 200){
                if(data.data != null&& data.data.cardId != null && data.data.cardId.length > 0){
                  this.fastPayInfo = data.data
                  console.log(this.fastPayInfo)
                  this.hasBankCard = true
                  this.bankNoText = '  （'+this.fastPayInfo.cardId+'）'
                }else{
                  this.hasBankCard = false
                }
            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'获取账号绑定银行卡信息异常',
                    type:'error'
                })
            }
          },(err)=>{
              console.log(err)
          })
      },

      getPayVerifyCode(){
          var codeParams = {
              bizOrderId:this.orderInfo.checkOrderId,
              bizType:"SH"
          }
          this.pay_vloading = true
          this.wjtHttp.post(this,'/api/adapay/v2/fastpay/sms',codeParams,false,(res)=>{
              this.pay_vloading = false
              var data = res.data
              if(data.code == 200){
                  this.$message({
                      message:'发送成功',
                      type:'success'
                  })
                  this.pay_verify_disable = true
                  clearInterval(this.pay_mInterval)
                  this.pay_mInterval = setInterval(() => {
                      if(this.pay_verify_second == 0){
                          this.pay_verify_disable = false
                          this.pay_verify_second = 60
                          clearInterval(this.pay_mInterval)
                          return
                      }
                      this.pay_verify_second--
                  }, 1000);
              }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'验证码获取失败，请联系管理员',
                      type:'error'
                  })
              }
          },(err)=>{
              this.pay_vloading = false
          })
      },
      //生成支付订单，获取验证码
      payApply(channel){
        this.wjtHttp.post(this,'/api/prescriptionCheck/v1/unifiedOrder',{
          checkOrderId:this.orderInfo.checkOrderId,
          payChannel:channel
        },false,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.paymentId = data.data.payResponse.paymentId
              if(channel == 'fast_pay'){
                this.payCodeDialogVisible = true
                this.pay_verify_disable = true
                clearInterval(this.pay_mInterval)
                this.pay_mInterval = setInterval(() => {
                    if(this.pay_verify_second == 0){
                        this.pay_verify_disable = false
                        this.pay_verify_second = 60
                        clearInterval(this.pay_mInterval)
                        return
                    }
                    this.pay_verify_second--
                }, 1000);
              }else if(channel == "alipay_qr"){ //支付宝
                this.qrcodeVisble =  true
                var outTradeNo = data.data.payResponse.alipayQrBase64
                this.qrCode ="data:image/jpeg;base64," + outTradeNo
                this.getPayStatus();
              }
            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'支付异常，请联系管理员',
                    type:'error'
                })
            }
        },(err)=>{
        })
      },
      getPayStatus(){
          if(this.zfbInterval != undefined && this.zfbInterval != null){
              clearInterval(this.zfbInterval)
          }
          this.zfbInterval = setInterval(()=>{
              this.wjtHttp.get(this,'/api/prescriptionCheck/v1/pay/status/'+this.orderInfo.checkOrderId,{},false,(res)=>{
              var data = res.data
              if(data.code == 200 && data.data.statusCode == 'succeeded'){
                this.$notify({
                          title: '成功',
                          message: '支付成功',
                          type: 'success',
                          duration:0
                        });
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1000);
                clearInterval(this.zfbInterval)
                this.qrcodeVisble = false
                this.payCodeDialogVisible = false
                this.bankDialogVisible = false
                this.fastPayStatusVisble = false
              }else if(data.data.statusCode == 'failed'){
                this.$notify({
                          title: '失败',
                          message: data.data.statusDesc?data.data.statusDesc:'交易失败，请重试',
                          type: 'success',
                          duration:0
                        });
                clearInterval(this.zfbInterval)
                this.qrcodeVisble = false
                this.payCodeDialogVisible = false
                this.bankDialogVisible = false
                this.fastPayStatusVisble = false
              }
          },(err)=>{
              console.log(err)
          })
          },3000)
      },
      toAddBank(){
          this.bankDialogVisible = true
      },
      //申请绑定银行卡（获取验证码）
      bindBank(){
        if(this.bindBankInfo.cardId.length == 0){
          this.$message("请输入银行卡号")
          return
        }
        if(this.bindBankInfo.userName.length == 0){
          this.$message("请输入姓名")
          return
        }
        if(this.bindBankInfo.idNo.length == 0){
          this.$message("请输入身份证号码")
          return
        }
        if(this.bindBankInfo.telNo.length == 0){
          this.$message("请输入手机号码")
          return
        }
        this.wjtHttp.post(this,'/api/adapay/v2/fastpay/card/apply',this.bindBankInfo,true,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.applyId = data.data.applyId
              this.bindCodeDialogVisible = true
              this.verify_disable = true
              clearInterval(this.mInterval)
              this.mInterval = setInterval(() => {
                  if(this.verify_second == 0){
                      this.verify_disable = false
                      this.verify_second = 60
                      clearInterval(this.mInterval)
                      return
                  }
                  this.verify_second--
              }, 1000);
            }else{
              this.$message({
                  message:(data.msg&&data.msg.length > 0)?data.msg:'绑定银行卡异常',
                  type:'error'
              })
            }
          },(err)=>{
              console.log(err)
          })
      },
      bindConfirm(){
        if(this.verify_code.length == 0){
          this.$message({
              message:'请先输入验证码',
              type:'error'
          })
        }
        this.wjtHttp.post(this,'/api/adapay/v2/fastpay/card/comfirm',{
          applyId:this.applyId,
          smsCode:this.verify_code,
          bizType:"SH"
        },true,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.bindCodeDialogVisible = false
              this.bankDialogVisible = false
              this.getPayChannels()
            }else{
              this.$message({
                  message:(data.msg&&data.msg.length > 0)?data.msg:'绑定银行卡异常',
                  type:'error'
              })
            }
          },(err)=>{
              console.log(err)
          })
      },
      pay(){
        if(this.currentChannel.length == 0){
          this.$message({
                  message:'请选择一个支付渠道',
                  type:'error'
              })
          return
        }
        if(this.currentChannel == 'fast_pay'){
          if(this.fastPayInfo == null || this.fastPayInfo.cardId == null || this.fastPayInfo.cardId.length == 0){
            this.bankDialogVisible = true
          }else{
            this.payApply('fast_pay')
          }
        }else if(this.currentChannel == 'alipay_qr'){
          this.payApply('alipay_qr')
        }
      },
      //获取验证码后支付按钮
      payConfirm(){
        if(this.pay_verify_code.length == 0){
          this.$message({
              message:'请输入验证码',
              type:'error'
          })
          return
        }
        this.wjtHttp.post(this,'/api/adapay/v2/fastpay/comfirm',{
          paymentId:this.paymentId,
          smsCode:this.pay_verify_code,
          bizOrderId:this.orderInfo.checkOrderId,
          bizType:"SH"
        },true,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.getPayStatus()
              this.fastPayStatusVisble = true
            }else{
              this.$message({
                  message:(data.msg&&data.msg.length > 0)?data.msg:'支付异常',
                  type:'error'
              })
            }
          },(err)=>{
              console.log(err)
          })
      },
    },

    watch:{
      verify_disable:function(val){
          if(val){
              this.btn_verify = this.verify_second+'后重发'
          }else{
              this.btn_verify = '获取验证码'
          }
      },
      verify_second:function(val){
          if(val < 60){
              this.btn_verify = val + '后重发'
          }
      },

      pay_verify_disable:function(val){
          if(val){
              this.pay_btn_verify = this.pay_verify_second+'后重发'
          }else{
              this.pay_btn_verify = '获取验证码'
          }
      },
      pay_verify_second:function(val){
          if(val < 60){
              this.pay_btn_verify = val + '后重发'
          }
      },
      qrcodeVisble: function(val){
        if(!val && this.zfbInterval != null && this.zfbInterval != undefined){
          clearInterval(this.zfbInterval)
        }
      },
      fastPayStatusVisble: function(val){
        if(!val && this.zfbInterval != null && this.zfbInterval != undefined){
          clearInterval(this.zfbInterval)
        }
      }
    },
    destroyed() {
      clearInterval(this.mInterval)
      clearInterval(this.interval)
      clearInterval(this.pay_mInterval)
      clearInterval(this.zfbInterval)
    }
  }
</script>

<style scoped>
  .container{
      width: 1160px;
      margin: auto auto;
      display: flex;
      flex-direction: column;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header>div{
      color:#333333;
      font-size: 20px;
  }
  .dialog-footer{
    margin-top: 50px;
  }
  .dialog{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 80px;
    padding-right: 80px;

  }
  .form-item{
    width: 100%;
  }
  .dialog-wrapper{
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .qrcode-dialog-text{
      color: #333333;
      font-size: 20px;
      margin-top: 30px;
  }
  .colomn-container{
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .row-container{
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .center{
    justify-content: center;
  }
  .center-align{
    align-items: center;
  }
  .pay-container{
    width: 100%;
    height: auto;
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #F2F2F2;
    -webkit-box-shadow: 1px 1px 6px #f2f2f2;
    box-shadow: 1px 1px 6px #f2f2f2;
  }
  .radio{
    width: 60%;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: start;
    padding-left: 50px !important;
    margin-left: 100px !important;
    height: 75px !important;
    padding-top: 20px !important;
  }
  .pay-icon{
    width: 26px;
    height: 26px;
    position: relative;
    top: 5px;
  }
  .el-radio__label{
    margin-left: 20px !important;
  }
  .btn-fast-pay{
    width: 200px;
    height: 44px;
    margin-left: calc(60% - 126px);
  }
  .btn-pay{
    width: 180px;
    height: 50px;
    margin-bottom: 30px;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay/wjtpayCheck.vue